import { Helpers } from '../../helpers';
import { IScheduleConstraintType } from '../../interfaces/ischedule-constraint-type';
import { ScheduleActivity } from '../schedule-activity';

export class ScheduleConstraintTypeBase {
  ScheduleConstraintTypeId: number;
  ScheduleConstraint: string;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;
  P6Constraint: string | null;

  ScheduleActivities_PrimaryConstraintType?: Array<ScheduleActivity> | null;

  constructor(item?: IScheduleConstraintType) {
    if (item) {

      this.ScheduleConstraintTypeId = item.ScheduleConstraintTypeId;
      this.ScheduleConstraint = item.ScheduleConstraint;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;
      this.P6Constraint = item.P6Constraint;

      this.ScheduleActivities_PrimaryConstraintType = Helpers.createClassArray(ScheduleActivity, item.ScheduleActivities_PrimaryConstraintType);
    }
  }
}